import { InsightsPageTemplate } from "@/components/templates/InsightsPageTemplate";
import { aiContentCluster, getRelatedMoneyPages, getRelatedInsightPages } from "@/data/contentClusters";

const pageData = aiContentCluster.insightPages.find(p => p.slug === "ai-content-vs-human-content")!;
const relatedMoney = getRelatedMoneyPages("ai-content").map(p => ({ title: p.title, slug: p.slug, pillarSlug: p.pillarSlug }));
const relatedInsights = getRelatedInsightPages("ai-content").map(p => ({ title: p.title, slug: p.slug }));

export default function AIContentVsHumanContentPage() {
  return (
    <InsightsPageTemplate
      page={pageData}
      relatedMoneyPages={relatedMoney}
      relatedInsightPages={relatedInsights}
    />
  );
}
